<template>
  <div class="mcp-sticky-banner-root">
    <div class="mcp-sticky-banner__img-anchor">
      <div class="mcp-sticky-banner__img-group">
        <div class="mcp-sticky-banner__img-wrap">
          <img
            class="mcp-sticky-banner__img"
            src="@/assets/mcp-sticky-banner-img.png"
            alt="Cricket MCP"
          />
        </div>
        <div class="mcp-sticky-banner__bubbles">
          <span class="bubble bubble--q bubble--s1-q">Most IPL titles?</span>
          <span class="bubble bubble--a bubble--s1-a">MI & CSK · 5 each</span>
          <span class="bubble bubble--q bubble--s2-q">Highest individual IPL score?</span>
          <span class="bubble bubble--a bubble--s2-a">Chris Gayle · 175* · RCB</span>
          <span class="bubble bubble--q bubble--s3-q">IPL 2026 final venue?</span>
          <span class="bubble bubble--a bubble--s3-a">Narendra Modi Stadium · 31 May</span>
        </div>
      </div>
    </div>
    <div class="mcp-sticky-banner">
      <div class="mcp-sticky-banner__inner">
        <div class="mcp-sticky-banner__content">
          <p class="mcp-sticky-banner__text">
            CricketAPI is now AI ready, Introducing the
            <strong>Cricket MCP</strong>
            for ChatGPT, Claude, Perplexity and more!
          </p>
          <a class="mcp-sticky-banner__btn" :href="knowMoreUrl">
            Explore MCP
            <span class="mcp-sticky-banner__arrow">›</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.mcp-sticky-banner-root {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: auto;
  min-height: size(56);
  overflow: visible;
  z-index: calc(var(--slidein-z-index) - 1);
  display: block;
}

.mcp-sticky-banner__img-anchor {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  min-height: size(56);
  height: auto;
  max-width: size(835);
  margin: 0 auto;
  padding: 0 size(16);
  pointer-events: none;
  display: none;

  @media screen and (min-width: $breakpoint-lg) {
    display: block;
  }
}

// Set by MasterMenuNavMain when the open endpoints dropdown overlaps the mascot
.mcp-mascot-hidden .mcp-sticky-banner__img-anchor {
  opacity: 0;
  visibility: hidden;
  transition: opacity 200ms ease-in, visibility 200ms;
}

.mcp-sticky-banner__img-group {
  position: absolute;
  bottom: 0;
  left: -8%;
  width: size(290);
  height: size(56);
}

.mcp-sticky-banner__img-wrap {
  position: absolute;
  bottom: 84%;
  left: 0;
  width: size(290);
  height: size(266);
}

.mcp-sticky-banner__img {
  width: size(290);
  height: size(266);
  object-fit: contain;
  object-position: bottom;
}

/* total cycle = 24s, 3 sets × 8s each
   Q: appears 0-0.5s, holds until ~6s, fades by 7s
   A: delay +1.5s, holds until ~7s, fades by 7.5s */
@keyframes chat-q {
  0%   { opacity: 0; transform: translateY(size(4)); }
  2%   { opacity: 1; transform: translateY(0); }
  22%  { opacity: 1; }
  27%  { opacity: 0; transform: translateY(size(-3)); }
  100% { opacity: 0; }
}

@keyframes chat-a {
  0%   { opacity: 0; transform: translateY(size(4)); }
  2%   { opacity: 1; transform: translateY(0); }
  18%  { opacity: 1; }
  23%  { opacity: 0; transform: translateY(size(-3)); }
  100% { opacity: 0; }
}

.mcp-sticky-banner__bubbles {
  position: absolute;
  bottom: 148%;
  left: size(-80);
  width: 200px;
  pointer-events: none;

  .bubble {
    position: absolute;
    width: max-content;
    white-space: nowrap;
    border-radius: size(10);
    padding: size(8) size(10);
    font-size: size(14);
    line-height: size(16);
    font-family: "New Hero", var(--rz-para-font), sans-serif;
    box-shadow: 0 size(2) size(8) rgba(0, 0, 0, 0.12);
    opacity: 0;
    animation-duration: 24s;
    animation-iteration-count: infinite;
    animation-timing-function: ease-in-out;

    &--q {
      bottom: size(58);
      right: size(8);
      background: #F1DB90;
      font-weight: 500;
      color: #333;
      animation-name: chat-q;
    }

    &--a {
      bottom: size(16);
      left: size(-40);
      background: #111;
      color: #fff;
      font-weight: 600;
      animation-name: chat-a;
    }

    &--s1-q { animation-delay: 0s; }
    &--s1-a { animation-delay: 1.5s; }
    &--s2-q { animation-delay: 8s; }
    &--s2-a { animation-delay: 9.5s; }
    &--s3-q { animation-delay: 16s; }
    &--s3-a { animation-delay: 17.5s; }
  }
}

.mcp-sticky-banner {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  min-height: size(56);
  height: auto;
  background: linear-gradient(90deg, #F89B89 0%, #F89559 28%, #F4B8B0 65%, #E5C8F2 100%);
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: size(8) 0;

  &__inner {
    max-width: size(835);
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 size(16);
  }

  &__content {
    display: flex;
    align-items: center;
    gap: size(18);
    justify-content: center;
    width: 100%;
  }

  &__text {
    color: #111;
    font-family: "New Hero", var(--rz-para-font), sans-serif;
    font-size: size(12);
    font-weight: 400;
    line-height: normal;
    margin: 0;
    white-space: normal;
    text-align: center;

    strong {
      font-weight: 700;
    }

    @media screen and (min-width: #{size(768)}) {
      font-size: size(13);
      white-space: nowrap;
      text-align: left;
    }

    @media screen and (min-width: #{size(1024)}) {
      font-size: size(15);
    }
  }

  &__btn {
    display: flex;
    padding: size(8) size(12);
    justify-content: center;
    align-items: center;
    gap: size(10);
    background: #111;
    border-radius: size(4);
    text-decoration: none;
    white-space: nowrap;
    flex-shrink: 0;
    color: #FFF;
    font-family: "New Hero", var(--rz-para-font), sans-serif;
    font-size: size(12);
    font-weight: 500;
    line-height: normal;

    &:hover {
      background: #333;
      color: #FFF;
    }
  }

  &__arrow {
    font-size: size(14);
  }

}
</style>

<script>
export default {
  name: 'McpStickyBanner',
  props: {
    knowMoreUrl: {
      type: String,
      default: '/v5/mcp/',
    },
  },
  mounted() {
    // Expose banner height so other fixed UI (e.g. nav dropdowns) can stay above it
    if (typeof ResizeObserver === 'undefined') {
      this.setBannerHeightVar();
      return;
    }
    this.resizeObserver = new ResizeObserver(() => this.setBannerHeightVar());
    this.resizeObserver.observe(this.$el);
  },
  beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    document.documentElement.style.removeProperty('--mcp-banner-height');
  },
  methods: {
    setBannerHeightVar() {
      document.documentElement.style.setProperty('--mcp-banner-height', `${this.$el.offsetHeight}px`);
    },
  },
};
</script>
